import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { QrCode } from "lucide-react";
import { useAuth } from "@/lib/auth/AuthContext";
import { TotpEnrollmentFlow } from "@/components/auth/TotpEnrollmentFlow";
import { AuthLayout } from "./AuthLayout";

export function TotpEnrollPage() {
  const { state, beginEnrollment, confirmEnrollment, checkSessionAfterEnrollment, resetToLogin } =
    useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.status === "unauthenticated" || state.status === "session_expired") {
      navigate("/login", { replace: true });
    }
  }, [state.status, navigate]);

  if (state.status === "authenticated") {
    return <Navigate to="/" replace />;
  }
  if (state.status !== "totp_challenge") {
    return null;
  }

  return (
    <AuthLayout
      icon={<QrCode className="h-6 w-6" aria-hidden="true" />}
      title="Configurar autenticador"
      description={`Vincula un autenticador para ${state.email} antes de continuar.`}
      footer={
        <button
          type="button"
          className="text-ink-faint hover:text-ink hover:underline"
          onClick={resetToLogin}
        >
          Cancelar y volver al inicio de sesion
        </button>
      }
    >
      <TotpEnrollmentFlow
        onEnroll={beginEnrollment}
        onConfirm={confirmEnrollment}
        onComplete={async () => {
          const result = await checkSessionAfterEnrollment();
          if (result === "authenticated") {
            navigate("/", { replace: true });
          } else {
            navigate("/login/totp", { replace: true });
          }
        }}
      />
    </AuthLayout>
  );
}
